import LoginForm from './login-form.vue'
import AccountUsers from './user-management/account-users.vue'
import {createVueInstance} from "../../vue-root";

createVueInstance({
    name: 'account',
    components: { 
        LoginForm,
        AccountUsers
    }
});